var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 22C19.1802 22.0003 19.674 22.1981 20.0458 22.5525C20.4175 22.907 20.6386 23.3909 20.6633 23.9039C20.688 24.4169 20.5143 24.9198 20.1784 25.3083C19.8424 25.6968 19.3698 25.9411 18.8586 25.9907L18.6666 26H13.3333C12.8196 25.9997 12.3258 25.8019 11.9541 25.4475C11.5823 25.093 11.3612 24.6091 11.3366 24.0961C11.3119 23.5831 11.4855 23.0802 11.8215 22.6917C12.1575 22.3032 12.63 22.0589 13.1413 22.0093L13.3333 22H18.6666ZM22.6666 14C23.197 14 23.7057 14.2107 24.0808 14.5858C24.4559 14.9609 24.6666 15.4696 24.6666 16C24.6666 16.5304 24.4559 17.0391 24.0808 17.4142C23.7057 17.7893 23.197 18 22.6666 18H9.33325C8.80282 18 8.29411 17.7893 7.91904 17.4142C7.54397 17.0391 7.33325 16.5304 7.33325 16C7.33325 15.4696 7.54397 14.9609 7.91904 14.5858C8.29411 14.2107 8.80282 14 9.33325 14H22.6666ZM26.6666 6C27.197 6 27.7057 6.21071 28.0808 6.58579C28.4559 6.96086 28.6666 7.46957 28.6666 8C28.6666 8.53043 28.4559 9.03914 28.0808 9.41421C27.7057 9.78929 27.197 10 26.6666 10H5.33325C4.80282 10 4.29411 9.78929 3.91904 9.41421C3.54397 9.03914 3.33325 8.53043 3.33325 8C3.33325 7.46957 3.54397 6.96086 3.91904 6.58579C4.29411 6.21071 4.80282 6 5.33325 6H26.6666Z",
    fill: "#314450"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/Ic_sort.b3eab23d7714c4c37c4289d5a78abf39.svg";
export { ForwardRef as ReactComponent };